import NightingaleChart from "../../../Components/Charts/RetailNightingleChart";
import { useQuery } from "@tanstack/react-query";
import { Loader } from "rsuite";
import { axInst } from "../../../Components/Login/Service";
import { useSelector } from "react-redux";
import WaterMark from "../../../Components/WaterMark/WaterMark";

const fuel_type_stock = async (body) => {
  try {
    const res = await axInst.post("stocks/fuel-wise-stocks", body);
    return res.data.fuel_wise_stocks;
  } catch (error) {
    console.error(error);
    throw new Error("Failed to fetch fuel type stock data");
  }
};

const FuelTypewise = () => {
  const { data, submitted } = useSelector((e) => e.filtersStock);

  const {
    data: fuelType,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["fuel", submitted],
    queryFn: () => fuel_type_stock(data),
    cacheTime: 0,
    staleTime: 0,
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });

  return (
    <div className="relative">
      {isFetching && (
        <div className="grid items-center justify-center w-full h-full">
          <Loader />
        </div>
      )}
      {isError && (
        <div className="grid items-center justify-center w-full h-full">
          <p>Error Occurred</p>
        </div>
      )}
      <WaterMark />
      {!isFetching && !isError && (
        <div>
          <NightingaleChart
            data={fuelType}
            heading="Fuel Type Wise Stocks"
            h="230"
          />
        </div>
      )}
    </div>
  );
};
export default FuelTypewise;
